import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchWeatherFailure,
  fetchWeatherStart,
  fetchWeatherSuccess,
} from "../../store/features/weather/weatherSlice";

const URL = `${process.env.REACT_APP_WEATHER_API_URL}history.json`;
const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

const fetchWeatherApi = async (query, date, today) => {
  try {
    const response = await axios.get(URL, {
      params: {
        key: WEATHER_API_KEY,
        q: query,
        dt: date,
        end_dt: today,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchWeatherSaga(action) {
  try {
    const { q, date, today } = action.payload;
    const weatherData = yield call(fetchWeatherApi, q, date, today);
    yield put(fetchWeatherSuccess(weatherData));
  } catch (error) {
    yield put(fetchWeatherFailure(error.message));
  }
}

export default function* weatherSaga() {
  yield takeLatest(fetchWeatherStart.type, fetchWeatherSaga);
}
